import { FieldValues } from 'react-hook-form';
import { ESP_ACCOUNT_PAYLOAD_FIELDS } from '../../../../types';
import { ConnectedInputField } from '../../Shared/ConnectedInputField';
import { CreateModalRHF } from '../../Shared/CreateModalRHF';
import { CustomHeadersFields } from '../../Shared/CustomHeadersFields';
import { useModalsContext } from '../../../../contexts';
import { useCreateAccount } from '../../../../hooks';
import { createCustomEmailAccountPayload } from './CustomEmail.utils';
import { OAuthGroupGrid, UnspacedSubtitle2 } from './CustomEmail.styled';

const { NAME, API_ENDPOINT, CLIENT_ID, CLIENT_SECRET, TOKEN_ENDPOINT, CUSTOM_HEADERS } =
  ESP_ACCOUNT_PAYLOAD_FIELDS;

export const CustomEmailCreateModal = () => {
  const { hideModal } = useModalsContext();

  const { createAccount } = useCreateAccount();

  const onSubmit = (values: FieldValues) => {
    const payload = createCustomEmailAccountPayload(values);
    createAccount(payload);
    hideModal();
  };

  return (
    <CreateModalRHF headerText="Connect a custom email platform account" onSubmit={onSubmit}>
      <ConnectedInputField name={NAME} labelText="Name" />
      <ConnectedInputField
        name={API_ENDPOINT}
        labelText="Endpoint"
        placeholder="Example: https://www.endpointurl.com"
      />
      <UnspacedSubtitle2>OAuth 2.0</UnspacedSubtitle2>
      <OAuthGroupGrid>
        <ConnectedInputField name={CLIENT_ID} labelText="Client ID" />
        <ConnectedInputField name={CLIENT_SECRET} labelText="Client secret" />
      </OAuthGroupGrid>
      <ConnectedInputField
        name={TOKEN_ENDPOINT}
        labelText="Token URL"
        placeholder="Example: https://www.endpointurl.com"
      />
      <CustomHeadersFields name={CUSTOM_HEADERS} />
    </CreateModalRHF>
  );
};
